var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05175 13.0478C5.91637 13.0478 3.375 12.1421 3.375 10.9283C3.375 10.2949 4.06687 9.72452 5.175 9.32177C6.04012 9.87696 7.49081 10.1616 9.13613 10.1616C10.7426 10.1616 12.1624 9.81452 13.0343 9.28296C14.0799 9.68065 14.7291 10.2358 14.7291 10.8478C14.7291 12.0634 12.1877 13.0478 9.05175 13.0478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0855 9.88881C6.70838 9.88881 4.78125 9.1435 4.78125 8.22381C4.78125 7.71419 5.37525 7.25744 6.30675 6.95312C6.97162 7.30019 7.96781 7.52181 9.0855 7.52181C10.2032 7.52181 11.1994 7.30019 11.8642 6.95369C12.7974 7.25913 13.3898 7.71419 13.3898 8.22381C13.3914 9.1435 11.4638 9.88881 9.0855 9.88881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06975 7.245C7.23207 7.245 5.742 6.62962 5.742 5.8725C5.742 5.11594 7.23263 4.5 9.06975 4.5C10.9069 4.5 12.3975 5.11594 12.3975 5.8725C12.3975 6.62962 10.9069 7.245 9.06975 7.245Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBal);
export default __webpack_public_path__ + "static/media/bal.4c9945c1533c126ace2504dd585d9a2c.svg";
export { ForwardRef as ReactComponent };